import React, {Component} from 'react';
import Select from 'react-select';
import data from './countries.json';
import './Dialogs.min.css';

class CustomerDialogs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            country: null
        };
    }
    countryChange = (country) => {
        this.setState({
            country: country
        })
    }
    validateInput = () =>  {
        var customer = {};
        var valid = true;
        var inputs = document.querySelectorAll(".dlg_cell");
        var email_regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var phone_regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

        //remove errors
        for(var i=0; i<inputs.length; i++){
            inputs[i].querySelector("div:first-child").classList.remove("dlg_error");
        }

        //validate
        customer.firstName = inputs[0].querySelector("input").value.trim();
        if(customer.firstName == ""){
            valid = false;
            inputs[0].querySelector("div:first-child").classList.add("dlg_error");
        }

        customer.lastName = inputs[1].querySelector("input").value.trim();
        if(customer.lastName == ""){
            valid = false;
            inputs[1].querySelector("div:first-child").classList.add("dlg_error");
        }

        customer.email = inputs[2].querySelector("input").value.trim();
        if(!email_regex.test(String(customer.email.toLowerCase()))){
            valid = false;
            inputs[2].querySelector("div:first-child").classList.add("dlg_error");
        }

        customer.company= inputs[3].querySelector("input").value.trim();
        if(customer.company == ""){
            valid = false;
            inputs[3].querySelector("div:first-child").classList.add("dlg_error");
        }

        customer.phone = inputs[4].querySelector("input").value.trim();
        if(customer.phone == ""){
        //if(customer.phone != "" && !phone_regex.test(String(customer.phone.toLowerCase()))){
            valid = false;
            inputs[4].querySelector("div:first-child").classList.add("dlg_error");
        }

        if(this.state.country){
            customer.country = this.state.country.value;
        }else{
            valid = false;
            inputs[5].querySelector("div:first-child").classList.add("dlg_error");
        }

        //customer.country = inputs[5].querySelector("select").value.trim();
        //if(customer.country == "**"){
            //valid = false;
            //inputs[5].querySelector("div:first-child").classList.add("dlg_error");
        //}

        customer.projectName = inputs[6].querySelector("input").value.trim();
        if(customer.projectName == ""){
            valid = false;
            inputs[6].querySelector("div:first-child").classList.add("dlg_error");
        }

        customer.mailingList= document.querySelector('#dlg_customer input[type = "checkbox"]').checked;

        if(valid){
            //return customer info
            this.props.onClick(this.props.type, customer);
        }
    }
    render() {
        return (
            <div id="dlg_customer" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png"/>
                        <div className="dlg_title_txt">User Information</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null, false)}>X</div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_grey">
                            <div className="dlg_head">Please tell us about yourself</div>
                            <div className="dlg_table">
                                <div className="dlg_row">
                                    <div id="firstName" className="dlg_cell">
                                        <div>First Name*</div>
                                        <div><input className="dlg_input"/></div>
                                    </div>
                                    <div id="lastName" className="dlg_cell">
                                        <div>Last Name*</div>
                                        <div><input className="dlg_input"/></div>
                                    </div>
                                </div>
                                <div className="dlg_row">
                                    <div id="address" className="dlg_cell">
                                        <div>Email Address*</div>
                                        <div><input className="dlg_input"/></div>
                                    </div>
                                    <div id="company" className="dlg_cell">
                                        <div>Company*</div>
                                        <div><input className="dlg_input"/></div>
                                    </div>
                                </div>
                                <div className="dlg_row">
                                    <div id="phone" className="dlg_cell">
                                        <div>Phone Number*</div>
                                        <div><input className="dlg_input"/></div>
                                    </div>
                                    <div id="country" className="dlg_cell">
                                        <div className="label">Country*</div>
                                        {/*<select size='8' style={{height: "auto"}}>
                                            {data.countries.map((country, index) => <option key={index} value={country.value}>{country.label}</option>)}
                                        </select>*/}
                                        <Select value={this.state.country} onChange={this.countryChange} options={data.countries} className="countrySelect"/>
                                    </div>
                                </div>
                                <div className="dlg_row">
                                    <div id="projectName" className="dlg_cell">
                                        <div>Project Name*</div>
                                        <div><input className="dlg_input"/></div>
                                    </div>
                                </div>
                            </div>
                            <div className="mailList">
                                <input id="mailingList" type="checkbox"/>
                                <span className="dlg_text">&nbsp;Please check this box to receive emails on products, upcoming events, and more!</span>
                            </div>
                            <br/>
                            <div style={{
                                    fontWeight: "bold"
                                }}>* Required
                            </div>
                        </div>
                        <div id="dlg_export_btn_1" className="dlg_btn" onClick={() => this.validateInput()}>NEXT</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomerDialogs;
